import React from "react";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { BnbLabel } from "../../../utils/labels";
import type { ConfigCodeModalType } from "../../../utils/modalConstants";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import { useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";
import TyCodeBlock from "../../common/TyCodeBlock";

const ConfigCodeModal = (props: ModalViewType<ConfigCodeModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;

    const closeLabel = useCommonLabel("close");

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show}>
            <Modal.Header>
                <Modal.Title isCentered>
                    <BnbLabel label="yourCode" />
                </Modal.Title>
                <Modal.Button type="button" aria-label={closeLabel} onClick={close}>
                    <IconWrapper aria-hidden="true">
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body noSpacing>
                <TyCodeBlock />
            </Modal.Body>
        </ModalBaseView>
    );
};

export default ConfigCodeModal;
